<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="isLoading">
            <BoardCategory :cateData="category" :selectedCate="selectedCate" />
            <BoardSubCategory :cateData="category" :selectedCate="selectedCate" />
            <ListDataPage :data="data" :modalOpen="modalOpen" />
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
    <div class="modal_container" v-show="modalCheck" @click.stop>
        <div class="modal_wrapper modal-1" @click.stop="">
            <div class="modal_header">
                <p>안내</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <form class="modal_box" @submit.prevent="() => checkPwd(modalNumber, this.$refs.pwd.value)">
                    <div class="title_row">
                        <p class="title">비밀번호를 입력해주세요.</p>
                    </div>
                    <div class="input_group">
                        <input type="password" placeholder="비밀번호를 입력해주세요." ref="pwd" />
                    </div>
                    <div class="button_group">
                        <button @click="modalOpen" type="button" class="cancle">취소</button>
                        <button type="submit">확인</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { getDownloadList, getDownloadCategory, checkDownloadDetail } from '@/api';
import BoardCategory from '@/components/Board/BoardCategory.vue';
import BoardSubCategory from '@/components/Board/BoardSubCategory.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import { setDownloadPassword } from '@/utils/downloadPassword';
import ListDataPage from '../../common/ListDataPage.vue';

export default {
    components: {
        LayoutSub,
        LoadingWrap,
        SubSection,
        BoardCategory,
        BoardSubCategory,
        ListDataPage,
    },
    data() {
        return {
            isLoading: false,
            modalCheck: false,
            modalNumber: null,
            data: null,
            selectedCate: {},
            category: [],
        };
    },
    async mounted() {
        const category = await getDownloadCategory(this.$route.query);
        this.category = category;
        if (!this.$route.query.page || !this.$route.query.cid || !this.$route.query.rootCid) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    cid: category.mainCate[0].cid,
                    rootCid: category.mainCate[0].cid,
                    page: 1,
                },
            });
            this.selectedCate = this.category.mainCate[0];
            const { paging: data } = await getDownloadList({
                cid: category.mainCate[0].cid,
                rootCid: category.mainCate[0].cid,
                page: 1,
            });
            this.data = data;
        } else {
            this.selectedCate = this.category.selectedCate;
            const { paging: data } = await getDownloadList(this.$route.query);
            this.data = data;
        }
        this.isLoading = true;
    },
    watch: {
        async $route(to, from) {
            if (!to.query.page || !to.query.cid || !to.query.rootCid) {
                this.$router.replace({
                    path: from.path,
                    query: {
                        ...from.query,
                    },
                });
                return;
            }

            const category = await getDownloadCategory(this.$route.query);
            this.category = category;
            this.selectedCate = this.category.selectedCate;

            const data = await getDownloadList(this.$route.query);
            this.data = data.paging;
        },
        modalCheck: function () {
            if (this.modalCheck) this.$lenis.stop();
            else this.$lenis.start();
        },
    },
    methods: {
        modalOpen: function (idx) {
            this.modalCheck = !this.modalCheck;
            if (this.modalCheck) {
                this.modalNumber = idx || null;
                this.$refs.pwd.value = "";
                this.$refs.pwd.focus();
                document.body.style.overflow = "hidden";
                this.$lenis.stop();
            } else {
                this.$lenis.start();
                document.body.style.overflow = "";
            }

            if (idx) this.modalNumber = idx;
        },
        checkPwd: async function (idx, pwd) {
            const result = await checkDownloadDetail({ idx, ...this.$route.query, password: pwd });
            if (result.err) {
                alert(result.err.response.data);
                this.$refs.pwd.value = '';
                this.$refs.pwd.focus();
            } else {
                setDownloadPassword(idx, pwd);
                this.$router.push({
                    path: `${this.$route.path}/${idx}`,
                    query: this.$route.query,
                });
            }
        },
    },
};
</script>
